<div 
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4"
    (click)="$event.preventDefault(); closeCreate();"
>
    <div class="w-full max-w-screen-sm flex flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <form 
                (ngSubmit)="$event.preventDefault(); saveNew();"
                [formGroup]="eventForm"
                class="w-full flex flex-col items-center justify-start gap-4"
            >
                <div class="w-full flex flex-row gap-2 items-center justify-between pb-4 border-b border-orange-200">
                    <h2 class="w-full oswald-font text-xl font-medium text-start text-nside-orange-400">
                        Create New Training Log
                    </h2>
                    <button
                        class="p-1 rounded-full hover:bg-gray-100"
                        (click)="$event.preventDefault(); closeCreate();"
                    >
                        <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                    </button>
                </div>
                <div class="w-full flex flex-col items-center gap-2 pb-4 border-b border-orange-200">
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Name:</p>
                        </div>
                        <div class="w-full flex flex-col items-center relative">
                            <input 
                                type="text"
                                formControlName="name"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                                placeholder="E.g., Drills Training"
                                (focus)="showSuggestions = true"
                                (blur)="hideSuggestions()"
                            >
                            <div
                                class="w-full text-start italic text-xs text-red-500" 
                                *ngIf="eventForm.get('name')?.invalid && (eventForm.get('name')?.touched || eventForm.get('name')?.dirty)"
                            >
                                <div *ngIf="eventForm.get('name')?.hasError('required')">
                                    This field is required.
                                </div>
                            </div>

                            <!-- Suggestions dropdown -->
                            <div *ngIf="showSuggestions && filteredSuggestions.length > 0"
                                class="absolute top-full left-0 mt-1 z-20 divide-y divide-gray-300 bg-white rounded-md w-full shadow-md max-h-48 overflow-y-auto">
                                <ul class="p-2">
                                    <li *ngFor="let suggestion of filteredSuggestions"
                                        (mousedown)="selectSuggestion(suggestion)"
                                        class="px-3 py-2 cursor-pointer hover:bg-gray-100">
                                        {{ suggestion }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Start Date:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <div class="w-full relative">
                                <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                    <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                                    </svg>
                                </div>
                                <input id="datepicker-date-start" #datepickerStartInput name="start" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2" placeholder="Select date start">
                            </div>
                        </div>
                    </div>
                    <!-- END DATE TO BE IMPLEMENTED LATER IF NEEDED -->
                    <!-- <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>End Date:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <div class="w-full relative">
                                <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">                                     
                                    <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                        <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                                    </svg>
                                </div>
                                <input id="datepicker-date-end" #datepickerEndInput name="end" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2" placeholder="Select date end">
                            </div>
                        </div>
                    </div> -->
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Time:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <div class="relative w-full">
                                <div class="absolute inset-y-0 start-0 top-0 flex items-center ps-3.5 pointer-events-none">
                                    <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                                        <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z" clip-rule="evenodd"/>
                                    </svg>
                                </div>
                                <input 
                                    type="time" 
                                    formControlName="time"
                                    class="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2" 
                                    min="09:00" max="18:00" required />
                            </div>
                            <div
                                class="w-full text-start italic text-xs text-red-500" 
                                *ngIf="eventForm.get('time')?.invalid && (eventForm.get('time')?.touched || eventForm.get('time')?.dirty)"
                            >
                                <div *ngIf="eventForm.get('time')?.hasError('required')">
                                    This field is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Duration:</p>
                        </div>
                        <div class="w-full flex items-center gap-2">
                            <div>
                                <input type="radio" id="1-hour" value="1 hour" class="hidden peer"
                                    formControlName="duration"
                                >
                                <label for="1-hour"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    1 hour
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="2-hours" value="2 hours" class="hidden peer"
                                    formControlName="duration"
                                >
                                <label for="2-hours"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    2 hours
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="3-hours" value="3 hours" class="hidden peer"
                                    formControlName="duration"
                                >
                                <label for="3-hours"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    3 hours
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="4-hours" value="4 hours" class="hidden peer"
                                    formControlName="duration"
                                >
                                <label for="4-hours"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    4 hours
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="whole-day" value="whole day" class="hidden peer"
                                    formControlName="duration"
                                >
                                <label for="whole-day"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    whole day
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Details:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea 
                                formControlName="details"
                                rows="3"
                                class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                placeholder="Report details..."
                            ></textarea>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Upload file:</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <input type="file" multiple (change)="onFileSelect($event)"
                            class="w-full h-10 flex items-center rounded bg-gray-50 text-sm"
                            />
                            <p class="pt-1 w-full text-start text-xs text-gray-500">
                                PDF, PNG, JPG or SVG (MAX. 2MB)
                            </p>
                            <div class="w-full text-start italic text-xs text-red-500"
                                *ngIf="eventForm.get('files')?.invalid && (eventForm.get('files')?.dirty || eventForm.get('files')?.touched)">
                                <div *ngIf="eventForm.get('files')?.hasError('invalidType')">
                                    Invalid file type. Please upload a PDF, PNG, JPG, or SVG.
                                </div>
                                <div *ngIf="eventForm.get('files')?.hasError('maxSizeExceeded')">
                                    File size exceeds 2MB limit.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button 
                        (click)="$event.preventDefault(); closeCreate();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                    <button
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': eventForm.invalid,
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': eventForm.valid
                        }"
                        [disabled]="eventForm.invalid"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>